export const HERO_HEIGHT = 50;
export const NAVBAR_HEIGHT = 50;
export const BREADCRUMB_HEIGHT = 40;
export const HEADER_HEIGHT = HERO_HEIGHT + NAVBAR_HEIGHT;

export const FOOTER_HEIGHT = 25;

export const NO_CONTENT_HEIGHT = HEADER_HEIGHT + BREADCRUMB_HEIGHT + FOOTER_HEIGHT;

export const PAGE_MENU_DRAWER_WIDTH = 170;
export const SUBPAGE_MENU_DRAWER_WIDTH = 210;
export const SIDEBAR_PANEL_DRAWER_WIDTH = 440;
export const TOC_WIDTH = 300; // Table of Contents width
